import { prepChat } from "../../encoding";
import { client } from "../../client";
import { AO_HOST } from "../../client/aoHost";
import { appendICLog } from "../../client/appendICLog";
import { fadeToTrack } from "../../client/musicFade";

/**
 * Handles a music change to an arbitrary resource.
 * @param {Array} args packet arguments
 */
export const handleMC = (args: string[]) => {
  const track = prepChat(args[1]);
  let charID = Number(args[2]);
  const showname = args[3] || "";
  const looping = Boolean(Number(args[4])) || false;
  const channel = Number(args[5]) || 0;
  // const fading = Number(args[6]) || 0; // unused in web

  let musicname;
  const trackTrim = track.trim();
  // An empty track name -- or AO2's sentinel "~stop.mp3" -- is a stop. Don't
  // build ".../sounds/music/..." as a source (it 404s as text/html and spams
  // the console); just fade out.
  const isStop = !trackTrim || trackTrim.toLowerCase() === "~stop.mp3";
  const src = isStop
    ? ""
    : trackTrim.startsWith("http")
      ? trackTrim
      : `${AO_HOST}sounds/music/${encodeURI(trackTrim.toLowerCase())}`;
  // Crossfade between tracks like the desktop client (new track starts
  // during the old one's fade-out).
  const targetVol = Number(
    (<HTMLInputElement>document.getElementById("client_mvolume"))?.value ?? 0.5,
  );
  fadeToTrack(client.viewport.music, channel, src, looping, targetVol);

  try {
    musicname = client.chars[charID].name;
  } catch (e) {
    charID = -1;
  }

  let looptext = "";

  if (looping)
      looptext = "(looping)";

  if (charID >= 0) {
    musicname = client.chars[charID].name;
    appendICLog(`changed music to ${track} ${looptext}`, showname, musicname);
  } else {
    appendICLog(`The music was changed to ${track} ${looptext}`, showname);
  }

  const nowPlaying = isStop ? "None" : track;
  const statusEl = document.getElementById("client_trackstatustext");
  if (statusEl) statusEl.innerText = nowPlaying;
  const npEl = document.getElementById("client_nowplaying_text");
  if (npEl) npEl.innerText = nowPlaying;
};
